import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Row,
  Col,
  Input,
  Form,
  Button,
  FormGroup,
  Label,
  FormText,
} from "reactstrap";

import questionnaireService from "../../services/questionnaireService";
import litigantMenuActions from "../../actions/litigantMenuActions";
import alertActions from "../../actions/alertActions";

const Questionnaire = () => {
  const menuOptions = useSelector(
    (state) => state.litigantMenu.litigantMenuOptions
  );
  const [questionnaire, setQuestionnaire] = useState({});
  const [acceptDisclaimer, setAcceptDisclaimer] = useState(false);
  const [formState, setFormState] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (menuOptions) {
      if (!menuOptions.hasCurrentQuestionnaire) {
        questionnaireService.getNewQuestionnaire().then((payload) => {
          setQuestionnaire(payload);
          setFormState(payload.formVmList);
        });
      } else {
        questionnaireService.getCurrentQuestionnaire().then((payload) => {
          setQuestionnaire(payload);
          setFormState(payload.formVmList);
        });
      }
    }
  }, [menuOptions]); //If we pass an empty array to useEffect, it’s only executed after the first render.

  const handleChange = (evt) => {
    //map target
    const { target } = evt;
    //create state dupe
    var dummyFormState = formState.slice();
    //set index
    var index = parseInt(target.name);
    //get object
    var arrayObject = dummyFormState[parseInt(index)];
    // update object
    arrayObject = { ...arrayObject, answerText: target.value };
    //replace original object with copy in formState
    dummyFormState[index] = arrayObject;
    //update state
    setFormState(dummyFormState);
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    if (!menuOptions.hasCurrentQuestionnaire) {
      questionnaireService.submitNewQuestionnaire(formState).then((result) => {
        dispatch(litigantMenuActions.getLitigantMenuOptions());
        dispatch(alertActions.success("Successfully created questionnaire."));
      });
    } else {
      questionnaireService.updateCurrentQuestionnaire(formState).then(() => {
        dispatch(alertActions.success("Successfully edited questionnaire."));
      });
    }
  };

  const getDropDownMenuItems = (dropDownMenuName) => {
    //console.log(dropDownMenuName);
    const getAll = questionnaire.dropDownGroups.filter(
      (x) => x.dropDownGroupName === dropDownMenuName
    );
    return getAll;
  };
  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <h1>Questionnaire</h1>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <h4>Federal Pro Se Clinic</h4>
          <p>
            Please read and acknowledge the rules and disclaimer below in order
            to access the questionnaire.
          </p>
          <h4>Federal Court Advice-Only Clinic Rules and Policies</h4>
          <p>
            Prior to meeting with a Advice-Only Clinic volunteer attorney you
            must:
          </p>
          <ul>
            <li>Read and acknowledge the Disclaimer (below)</li>
            <li>Complete the General Information Form</li>
          </ul>
          <h5>Your appointment:</h5>
          <ul>
            <li>
              Be early for your meeting with the volunteer attorney. We are sure
              your time is valuable, as is that of our attorneys.
            </li>
            <li>
              Be sure to make a list of your questions so that the volunteer
              lawyer can address all of your issues.
            </li>
            <li>
              If you are late for your meeting the next person waiting will be
              given your appointment. It may not be possible to reschedule you
              on that same date.
            </li>
            <li>
              If you are not able to make your meeting time, then you must call
              to cancel your meeting. Remember, hundreds of individuals need
              this service. If you fail to release your time slot then someone
              who is in desperate need may be told that they cannot be helped.
              Your appointment is limited to 20 or 30 minutes. Be aware of the
              time and try to honor the needs of the next person waiting to see
              the attorney.
            </li>
            <li>
              If you fail to make an appointment, it is possible that an
              attorney may see you; but to guarantee that appointment you must
              schedule with Clerk’s Office personnel in advance.
            </li>
            <li>
              There is no fee for meeting with the volunteer attorney, or for
              any of the documents in the Advice-Only Clinic.
            </li>
          </ul>
          <h5>Disclaimer:</h5>
          <p>
            The Volunteer Lawyers Program asks lawyers to volunteer to come to
            the Court for scheduled appointments to provide brief help for
            people with civil -not criminal- legal issues who do not have
            lawyers. This service is free. The Clinic offers brief appointments
            (20-30 minutes). The attorney may let you know what steps you can
            take about your case. The volunteer lawyers who help at the clinic
            have not agreed to go to court hearings or to file court documents
            for you.
          </p>
        </Col>
      </Row>

      <Row style={{ paddingBottom: "10px" }}>
        <Col xs={12}>
          <input
            type="checkbox"
            checked={acceptDisclaimer}
            onChange={() => setAcceptDisclaimer(!acceptDisclaimer)}
          />{" "}
          <b>I acknowledge the above disclaimer.</b>
        </Col>
      </Row>
      {menuOptions && (
        <Row className={!acceptDisclaimer ? "d-none" : ""}>
          <Col xs={12}>
            <h2>
              {" "}
              {!menuOptions.hasCurrentQuestionnaire ? "New " : "Edit "}{" "}
              {questionnaire ? questionnaire.questionnaireName : ""}
            </h2>
          </Col>
          <Col xs={12}>
            <Form onSubmit={(evt) => handleSubmit(evt)}>
              {formState.map((qq, i) => (
                <FormGroup row key={qq.questionnaireQuestionId}>
                  <Label sm={12}>{qq.questionText}</Label>
                  <Col sm={12}>
                    {!qq.yesNo && qq.dropDownGroupName === "" && (
                      <React.Fragment>
                        <Input
                          type="text"
                          name={i}
                          value={formState[i].answerText}
                          onChange={(evt) => {
                            handleChange(evt);
                          }}
                          style={{ width: "90%" }}
                          readOnly={menuOptions.hasAppointment ? true : false}
                        />
                        <br />
                      </React.Fragment>
                    )}
                    {!qq.yesNo && qq.dropDownGroupName !== "" && (
                      <React.Fragment>
                        <FormText>Select an option</FormText>
                        <Input
                          type="select"
                          name={i}
                          value={formState[i].answerText}
                          onChange={(evt) => {
                            handleChange(evt);
                          }}
                          style={{ width: "90%" }}
                          readOnly={menuOptions.hasAppointment ? true : false}
                        >
                          <option value="">Select an option below</option>
                          {getDropDownMenuItems(qq.dropDownGroupName).map(
                            (x) => (
                              <option
                                value={x.groupItemName}
                                key={x.groupItemName}
                              >
                                {x.groupItemName} - {x.groupItemDescription}
                              </option>
                            )
                          )}
                        </Input>

                        <br />
                      </React.Fragment>
                    )}
                    {qq.yesNo && (
                      <React.Fragment>
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="radio"
                              name={i}
                              checked={
                                formState[i].answerText === "false" ||
                                formState[i].answerText === ""
                              }
                              value="false"
                              onChange={(evt) => {
                                handleChange(evt);
                              }}
                              readOnly={
                                menuOptions.hasAppointment ? true : false
                              }
                            />{" "}
                            No
                          </Label>
                        </FormGroup>
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="radio"
                              name={i}
                              checked={formState[i].answerText === "true"}
                              value="true"
                              onChange={(evt) => {
                                handleChange(evt);
                              }}
                              readOnly={
                                menuOptions.hasAppointment ? true : false
                              }
                            />{" "}
                            Yes
                          </Label>
                        </FormGroup>
                        <br />
                      </React.Fragment>
                    )}
                  </Col>
                </FormGroup>
              ))}
              {!menuOptions.hasAppointment && (
                <Button type="submit">Submit</Button>
              )}
              {menuOptions.hasAppointment && (
                <span style={{ fontStyle: "italic" }}>
                  After an appointment has been scheduled you can no longer edit
                  your questionnire.
                </span>
              )}
            </Form>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

export default Questionnaire;
